const WARNED_MESSAGES = new Set<string>();

export const isDevelopment = typeof __DEV__ !== "undefined" && __DEV__;

export const warnOnce = ({
    message
}: {
    message: string;
}) => {
    if(!isDevelopment || WARNED_MESSAGES.has(message)) {
        return;
    }

    WARNED_MESSAGES.add(message);

    console.warn(message);
};
